import { Avatar, Button, Card, Icon, Tag, Typography } from "@ann/web-components";
import { TopContent, TopContentHeader, TopContentHeaderLeft, TopContentHeaderRight, MetadataContent, MetaItem, ActionContent } from "./AgentCard.styled";
import { useNavigate } from "react-router-dom";
const AgentCard = ({ agent }) => {
    const navigate = useNavigate();
    return (
        <Card>
            <TopContent>
                <TopContentHeader>
                    <TopContentHeaderLeft>
                        {/*
                        <Avatar
                            size="lg"
                            src="https://via.placeholder.com/150"
                        />
                        */}
                        <Typography category="subtitle" weight="bold" color="title" size="medium" maxCharacters={40}>
                            {agent.name}
                        </Typography>

                    </TopContentHeaderLeft>

                    {/*
                    <TopContentHeaderRight>
                        <Icon name="dotsMenu" />
                    </TopContentHeaderRight>
                    */}

                </TopContentHeader>
                <Typography category="subtitle" weight="bold" color="subtitle" size="small">
                    Service
                </Typography>
                <Typography category="body" weight="regular" color="body" size="medium" maxCharacters={100}>
                    {agent.description}
                </Typography>

            </TopContent>
            {/*
            <MetadataContent>
                <MetaItem>
                    <Tag
                        color="informative"
                        icon="person"
                        size="medium"
                    />
                    <Typography category="body" weight="regular" color="body" size="medium">
                        John Doe
                    </Typography>
                </MetaItem>
                <MetaItem>
                    <Tag
                        color="informative"
                        icon="sms"
                        size="medium"
                    />
                    <Typography category="body" weight="regular" color="body" size="medium">
                        125
                    </Typography>
                </MetaItem>
            </MetadataContent>
            */}
            <ActionContent>
                <Button
                    label="Edit"
                    size="medium"
                    type="secondary"
                    onClick={() => {
                        navigate(`/v2/playground2/${agent.uuid}/configuration`);
                    }}
                />
                <Button
                    label="Chat"
                    size="medium"
                    type="primary"
                    onClick={() => {
                        navigate(`/home?agent=${agent.uuid}`);
                    }}
                />

            </ActionContent>
        </Card>
    );
};

export default AgentCard;